import { getUrlVars } from "@/components/helpers/URL"
import LoggedInOutRoutesSwitch from "@/components/navigation/LoggedInOutRoutesSwitch"
import { Box } from "@mui/material"
import { captureException } from "@sentry/browser"
import PropTypes from "prop-types"
import { useEffect, useLayoutEffect, useRef } from "react"
import history from "routing/history"
import { APP_STYLES } from "./style-utils"

const propTypes = {
  login: PropTypes.func.isRequired,
  fetchInitialState: PropTypes.func.isRequired,
  setHasRouted: PropTypes.func.isRequired,
  loggedIn: PropTypes.bool.isRequired,
  hasRouted: PropTypes.bool.isRequired,
}

function App({ theme, login, fetchInitialState, setHasRouted, loggedIn, hasRouted }) {
  const historyStackCount = useRef(0)
  const hasRoutedRef = useRef(hasRouted)
  const setHasRoutedRef = useRef(setHasRouted)

  useLayoutEffect(() => {
    hasRoutedRef.current = hasRouted
    setHasRoutedRef.current = setHasRouted
  })

  useEffect(() => {
    const vars = getUrlVars()
    if (vars.email && vars.password) {
      login(vars.email, vars.password)
    }
    if (fetchInitialState && loggedIn) {
      fetchInitialState()
    }
  }, [])

  useLayoutEffect(
    () =>
      history.listen((update) => {
        if (update.action === "PUSH") {
          if (historyStackCount.current === 0 || !hasRoutedRef.current) {
            hasRoutedRef.current = true
            setHasRoutedRef.current(true)
          }
          historyStackCount.current += 1
        } else if (update.action === "POP") {
          if (historyStackCount.current === 1) {
            hasRoutedRef.current = false
            setHasRoutedRef.current(false)
          }
          historyStackCount.current -= 1
        }
      }),
    [],
  )

  const accentColor = theme.palette.primary[300]

  try {
    document.styleSheets[0].insertRule(
      `.heroicon-component-accent { fill: ${accentColor} !important;}`,
    )
  } catch (error) {
    captureException(error)
  }

  return (
    <Box id="appjsx" className="flex-center grow" sx={APP_STYLES.root}>
      <LoggedInOutRoutesSwitch />
    </Box>
  )
}

App.propTypes = propTypes

export default App
